import {DataTableColumn} from 'mantine-datatable';
import {NavLink} from 'react-router-dom';
import {Text} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {UsageEventRow} from '../types';
import {BillableBadge} from '../profile/Badges';
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from '../../../utils/TableTimestamps';
import {usageEventPath} from '../config';
import {MonoText} from '../components/MonoText';

const placeholder = TIMESTAMP_PLACEHOLDER;

export const useUsageEventsTableColumns = () => {

    const columns: DataTableColumn<UsageEventRow>[] = [
        {
            accessor: 'eventId',
            sortable: true,
            title: I18n.get('Event'),
            width: '1fr',
            // A real link as well as the row click, so the detail page is reachable from
            // the keyboard (§13).
            render: (item: UsageEventRow) => (
                <NavLink to={usageEventPath(item.id)} onClick={event => event.stopPropagation()}>
                    <Text size='xs' ff='monospace'>{item.eventId}</Text>
                </NavLink>
            ),
        },
        {
            accessor: 'meterCode',
            sortable: true,
            title: I18n.get('Meter'),
            width: '1fr',
            render: (item: UsageEventRow) => item.meterCode ?? placeholder,
        },
        {
            accessor: 'customerId',
            sortable: true,
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: UsageEventRow) => <MonoText value={item.customerId}/>,
        },
        {
            accessor: 'accountId',
            sortable: true,
            title: I18n.get('Account'),
            width: '1fr',
            render: (item: UsageEventRow) => <MonoText value={item.accountId}/>,
        },
        {
            accessor: 'quantity',
            sortable: true,
            title: I18n.get('Quantity'),
            width: '1fr',
            render: (item: UsageEventRow) => typeof item.quantity === 'number' ? String(item.quantity) : placeholder,
        },
        {
            accessor: 'occurredAt',
            sortable: true,
            title: I18n.get('Occurred'),
            width: '1fr',
            render: (item: UsageEventRow) => formatTimestamp(item.occurredAt),
        },
        {
            accessor: 'receivedAt',
            sortable: true,
            title: I18n.get('Ingested'),
            width: '1fr',
            render: (item: UsageEventRow) => formatTimestamp(item.receivedAt),
        },
        {
            // Sorts by `status`, the severity rank the list hook derives with the same
            // function the badge uses (utils/billableStatus), so ascending puts billable
            // rows first and descending puts unresolved-customer rows first.
            accessor: 'status',
            sortable: true,
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: UsageEventRow) => <BillableBadge record={item}/>,
        },
    ];

    return {
        columns,
    }
}
